import Repository from "./Repository";

const GetImageCategories = "/BrainstormUserSettingsApi/GetImageCategories";
const GetImage = "/BrainstormUserSettingsApi/GetImages";

export default {
  GetImageCategories(payload) {
    return Repository.post(`${GetImageCategories}`, payload);
  },
  GetImage(payload) {
    return Repository.post(`${GetImage}`, payload);
  }
};
